var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpeaker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 12.9282V7.06662C14 3.79038 14 2.15225 13.0354 1.74458C12.0709 1.33691 10.9357 2.49524 8.66529 4.81189C7.48953 6.01161 6.8187 6.27728 5.14583 6.27728C3.9874 6.27728 2.5703 6.12376 1.85111 7.22204C1.5 7.75821 1.5 8.50461 1.5 9.9974C1.5 11.4902 1.5 12.2366 1.85111 12.7728C2.5703 13.871 3.9874 13.7175 5.14583 13.7175C6.8187 13.7175 7.48953 13.9832 8.66529 15.1829C10.9357 17.4996 12.0709 18.6579 13.0354 18.2502C14 17.8425 14 16.2044 14 12.9282Z",
    stroke: "white",
    strokeWidth: 1.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeaker);
export default __webpack_public_path__ + "static/media/speaker.239682119e8837347f6e561411b3f093.svg";
export { ForwardRef as ReactComponent };